export const numberValue = (v: number | null | undefined): string => (v != null ? String(v) : "")

export const toNumber = (v: string): number | undefined => (v === "" ? undefined : Number(v))
